import getHeaderH from './getHeaderH';
import scrollTo from './scrollTo';

// スムーススクロール
const smoothScroll = () => {
    const headerisFixed= true; //ヘッダーが追従するかどうか

    const doWhenLoaded = () => {
        // すべてのaタグを取得し、href属性に#が含まれるものをフィルタリング
        const allLinks = document.querySelectorAll('a');
        const smoothScrollTrigger = Array.from(allLinks).filter(link => {
            const href = link.getAttribute('href');
            return href && href.includes('#');
        });

        // ヘッダーの高さを取得
        let headerH = 0;
        if (headerisFixed) {
            headerH = getHeaderH();
        }
    
        // aタグにそれぞれクリックイベントを設定
        for (let i = 0; i < smoothScrollTrigger.length; i++) {
            smoothScrollTrigger[i].addEventListener('click', (e) => {
                let href = smoothScrollTrigger[i].getAttribute('href'); // 各a要素のリンク先を取得
                
                // 現在のURLとリンク先のURLを比較
                const currentPath = window.location.pathname;
                const linkPath = href.split('#')[0]; // #以降を除去してパス部分のみを取得
                
                // パスが異なる場合（異なるページへのリンク）は通常の遷移を行う
                if (linkPath && linkPath !== currentPath) {
                    return; // イベントリスナーを終了し、通常の遷移を許可
                }
                
                // 同じページ内のアンカーリンクの場合のみスムーススクロールを適用
                e.preventDefault();
                
                // #以降の文字列を取得（#が複数ある場合は最後の#以降）
                let targetId = href.substring(href.lastIndexOf('#') + 1); // #を除去してIDを取得
                let targetElement = document.getElementById(targetId); // リンク先の要素（コンテンツ）を取得
                let target;
                
                if (targetElement) {
                    const rect = targetElement.getBoundingClientRect().top; // ブラウザからの高さを取得
                    const offset = window.scrollY; // 現在のスクロール量を取得
                    target = rect + offset - headerH; //最終的な位置を割り出す  
                    // console.log(`スクロール先: ${targetId}, 位置: ${target}px`);      
                } else {
                    // console.warn(`警告: ID "${targetId}" を持つ要素が見つかりません。`);
                    target = 0; //ターゲットが存在しない場合はTOPに移動
                }
    
                // スクロールさせる
                scrollTo(target);
            });
        }
    }

    // DOMContentLoadedイベントで処理を開始（画像などの読み込みを待たない）
    document.addEventListener('DOMContentLoaded', doWhenLoaded);
    
    // リサイズ時にも位置を再計算
    window.addEventListener('resize', doWhenLoaded);
    
    // 画像などの読み込みが完了した後にも位置を再計算（念のため）
    window.addEventListener('load', doWhenLoaded);
}

export default smoothScroll